import styled from 'styled-components';

export const CompanyButtonContainer = styled.div`
  width: 100%;
  display: flex;
  gap: 16px;
  flex-wrap: wrap;

  @media (max-width: 520px) {
    > * {
      width: 100% !important;
    }
  }
`;

export const ModalContainer = styled.div`
  width: 100%;
  margin: 24px 0;
`;

export const InputContainer = styled.div`
  margin-top: 24px;
  border-top: 1px solid ${p => p.theme.palette.colors.borderSoft};
  border-bottom: 1px solid ${p => p.theme.palette.colors.borderSoft};
  padding: 24px 0;
`;

export const ShareRow = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;

  @media (max-width: 640px) {
    align-items: stretch;
    flex-direction: column;
  }
`;
export const FormText = styled.div.attrs({
})`
    font-size: 18px;
    font-weight: 700;
    text-align: ${p => p.center ? `center` : 'left'};
    color: ${props => props.theme.palette.colors.text};
    margin-bottom: 8px;
    ${p => p.success ? `
            text-align: ;
        ` : ''};
`;

export const ShareLinkBox = styled.div`
  min-width: 0;
  flex: 1;
  padding: 12px 14px;
  border: 1px solid ${p => p.theme.palette.colors.inputBorder};
  border-radius: 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  user-select: all;
  background: ${p => p.theme.palette.colors.inputSurface};
  color: ${p => p.theme.palette.colors.text};
  box-shadow: inset 0 1px 0 ${p => p.theme.palette.colors.borderSoft};
`;

export const CopyButton = styled.button`
  width: 44px;
  min-width: 44px;
  height: 44px;
  border-radius: 10px;
  border: 1px solid ${p => p.theme.palette.colors.inputBorder};
  background: ${p => p.theme.palette.colors.surfaceElevatedStrong};
  color: ${p => p.theme.palette.colors.text};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s ease, border-color 0.2s ease, transform 0.2s ease;

  &:hover {
    transform: translateY(-1px);
    background: ${p => p.theme.palette.colors.badgeMuted};
    border-color: ${p => p.theme.palette.colors.borderStrong};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }

  @media (max-width: 640px) {
    width: 100%;
  }
`;

export const HelperText = styled.div`
  margin-top: 10px;
  font-size: 13px;
  font-weight: 500;
  color: ${props => props.theme.palette.colors.muted};
`;

export const CopiedText = styled.div`
  margin-top: 10px;
  font-size: 13px;
  
  color: ${p => p.theme.palette.success?.main || p.theme.palette.blue.main};
`;
